export default __webpack_public_path__ + "static/media/CJ_Stationary.bbd854e4.jpg";